import * as React from "react";

import styles from "./VacanciesCreated.module.css";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  Chip,
  IconButton,
} from "@mui/material";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../Components/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";

export default function HeaderVacanciesCreated({ onFiltersChange }) {
  const [selection, setSelection] = useState("");
  const [selectionDuration, setSelectionDuration] = useState("");
  const [customRangeOpen, setCustomRangeOpen] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const handleChange = (event, newValue) => {
    setSelection(newValue);
  };

  const getDurationLabel = (value) => {
    const labels = {
      0: "Today",
      1: "Last 30 Days",
      2: "This Month",
      3: "Last Month",
      4: "Last 90 Days",
      5: "Last 6 Months",
      6: "Last 1 Year",
      7: "Custom Range",
    };
    return labels[value] || "";
  };

  const formatDateRange = (startDate, endDate) => {
    return `${dayjs(startDate).format("YYYY-MM-DD")},${dayjs(endDate).format("YYYY-MM-DD")}`;
  };

  const handleChangeDuration = (event) => {
    const value = event.target.value;
    const today = dayjs().format("YYYY-MM-DD");
    let formattedRange = "";

    switch (value) {
      case 0: // Today
        formattedRange = today;
        break;
      case 1: // Last 30 Days
        const thirtyDaysAgo = dayjs().subtract(30, "day").format("YYYY-MM-DD");
        formattedRange = formatDateRange(thirtyDaysAgo, today);
        break;
      case 2: // This Month
        const startOfMonth = dayjs().startOf("month").format("YYYY-MM-DD");
        formattedRange = formatDateRange(startOfMonth, today);
        break;
      case 3: // Last Month
        const startOfLastMonth = dayjs()
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD");
        const endOfLastMonth = dayjs()
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD");
        formattedRange = formatDateRange(startOfLastMonth, endOfLastMonth);
        break;
      case 4: // Last 90 Days
        const ninetyDaysAgo = dayjs().subtract(90, "day").format("YYYY-MM-DD");
        formattedRange = formatDateRange(ninetyDaysAgo, today);
        break;
      case 5: // Last 6 Months
        const sixMonthsAgo = dayjs().subtract(6, "month").format("YYYY-MM-DD");
        formattedRange = formatDateRange(sixMonthsAgo, today);
        break;
      case 6: // Last 1 Year
        const oneYearAgo = dayjs().subtract(1, "year").format("YYYY-MM-DD");
        formattedRange = formatDateRange(oneYearAgo, today);
        break;
      case 7: // Custom Range
        setCustomRangeOpen(true);
        return;
      default:
        formattedRange = "";
    }

    setSelectionDuration(formattedRange);
    updateFilters(formattedRange, statusFilter, searchText);
  };

  const handleCustomRangeSubmit = () => {
    if (customStartDate && customEndDate) {
      const formattedRange = formatDateRange(customStartDate, customEndDate);
      setSelectionDuration(formattedRange);
      updateFilters(formattedRange, statusFilter, searchText);
    }
    setCustomRangeOpen(false);
  };

  const handleStatusChange = (event) => {
    const value = event.target.value;
    setStatusFilter(value);
    updateFilters(selectionDuration, value, searchText);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchText(value);
    updateFilters(selectionDuration, statusFilter, value);
  };

  const updateFilters = (duration, status, search) => {
    if (onFiltersChange) {
      onFiltersChange({
        timestamps: duration,
        Status: status,
        search: search,
      });
    }
  };

  const handleClearAll = () => {
    setSelectionDuration("");
    setStatusFilter("");
    setSearchText("");
    setSelection("");
    setCustomStartDate(null);
    setCustomEndDate(null);

    if (onFiltersChange) {
      onFiltersChange({
        timestamps: "",
        Status: "",
        search: "",
      });
    }
  };

  const hasActiveFilters = selectionDuration || statusFilter || searchText;

  const handleClearDuration = () => {
    setSelectionDuration("");
    setSelection("");
    updateFilters("", statusFilter, searchText);
  };

  const handleClearStatus = () => {
    setStatusFilter("");
    updateFilters(selectionDuration, "", searchText);
  };

  const handleClearSearch = () => {
    setSearchText("");
    updateFilters(selectionDuration, statusFilter, "");
  };

  return (
    <Box className={styles.top}>
      <Box
        sx={{
          width: "280px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={styles.box}
      >
        <p
          style={{
            marginRight: "10px",
            fontSize: "16px",
            color: "#333",
            fontWeight: 540,
            minWidth: "70px",
          }}
        >
          Duration
        </p>
        <Box sx={{ position: "relative", width: "180px" }}>
          <Select
            value={selection}
            onChange={handleChangeDuration}
            displayEmpty
            renderValue={(selected) => {
              if (selected === "") {
                return (
                  <span style={{ color: "#666", fontSize: "14px" }}>
                    Select Duration
                  </span>
                );
              }
              return <span style={{ fontSize: "14px" }}>{getDurationLabel(selected)}</span>;
            }}
            sx={{
              width: "180px",
              height: "36px",
              bgcolor: "#f5f5f5",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "#1d82f5",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1d82f5",
                },
              },
              "& .MuiSelect-select": {
                padding: "8px 32px 8px 12px",
                fontSize: "14px",
              },
            }}
            IconComponent={(props) => (
              <ExpandMoreIcon {...props} style={{ color: "#666", fontSize: "20px" }} />
            )}
          >
            <MenuItem value="">Select Duration</MenuItem>
            <MenuItem value={0}>Today</MenuItem>
            <MenuItem value={1}>Last 30 Days</MenuItem>
            <MenuItem value={2}>This Month</MenuItem>
            <MenuItem value={3}>Last Month</MenuItem>
            <MenuItem value={4}>Last 90 Days</MenuItem>
            <MenuItem value={5}>Last 6 Months</MenuItem>
            <MenuItem value={6}>Last 1 Year</MenuItem>
            <MenuItem value={7}>Custom Range</MenuItem>
          </Select>
          {selectionDuration && (
            <IconButton
              size="small"
              onClick={handleClearDuration}
              sx={{
                position: "absolute",
                right: "32px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#666",
                "&:hover": { color: "#1d82f5" },
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
        <Dialog
          open={customRangeOpen}
          onClose={() => setCustomRangeOpen(false)}
          PaperProps={{
            sx: {
              borderRadius: 2,
              minWidth: "400px",
            },
          }}
        >
          <DialogContent sx={{ bgcolor: "#fff", color: "#000", padding: "24px" }}>
            <Typography
              variant="h6"
              gutterBottom
              style={{ color: "#333", fontWeight: 600, marginBottom: "20px" }}
            >
              Select Date Range
            </Typography>

            <Stack direction="column" spacing={3}>
              <Box>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ color: "#666", marginBottom: "8px", fontWeight: 500 }}
                >
                  Start Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={customStartDate}
                    onChange={(newValue) => setCustomStartDate(newValue)}
                    maxDate={customEndDate || dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          bgcolor: "#f5f5f5",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#e0e0e0",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1d82f5",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1d82f5",
                            },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              <Box>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ color: "#666", marginBottom: "8px", fontWeight: 500 }}
                >
                  End Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={customEndDate}
                    onChange={(newValue) => setCustomEndDate(newValue)}
                    minDate={customStartDate}
                    maxDate={dayjs()}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        sx: {
                          bgcolor: "#f5f5f5",
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#e0e0e0",
                            },
                            "&:hover fieldset": {
                              borderColor: "#1d82f5",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#1d82f5",
                            },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>

              {customStartDate && customEndDate && (
                <Box
                  sx={{
                    p: 2,
                    bgcolor: "#e3f2fd",
                    borderRadius: 1,
                    border: "1px solid #bbdefb",
                  }}
                >
                  <Typography variant="body2" color="#1976d2">
                    <strong>Selected Range:</strong> {dayjs(customStartDate).format("DD-MM-YYYY")} to {dayjs(customEndDate).format("DD-MM-YYYY")}
                  </Typography>
                </Box>
              )}
            </Stack>
          </DialogContent>
          <DialogActions sx={{ bgcolor: "#fff", color: "#000", padding: "16px 24px" }}>
            <Button
              onClick={() => setCustomRangeOpen(false)}
              sx={{
                color: "#666",
                "&:hover": { bgcolor: "#f5f5f5" },
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleCustomRangeSubmit}
              disabled={!customStartDate || !customEndDate}
              variant="contained"
              sx={{
                bgcolor: "#1d82f5",
                "&:hover": { bgcolor: "#1565c0" },
                "&:disabled": { bgcolor: "#ccc" },
              }}
            >
              Apply Filter
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

      <Box
        sx={{
          width: "220px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={styles.box}
      >
        <p
          style={{
            marginRight: "10px",
            fontSize: "16px",
            color: "#333",
            fontWeight: 540,
            minWidth: "50px",
          }}
        >
          Status
        </p>
        <Box sx={{ position: "relative", width: "140px" }}>
          <Select
            value={statusFilter}
            onChange={handleStatusChange}
            displayEmpty
            renderValue={(selected) => {
              if (selected === "") {
                return (
                  <span style={{ color: "#666", fontSize: "14px" }}>
                    All Status
                  </span>
                );
              }
              return (
                <span style={{ fontSize: "14px" }}>
                  {selected === "1" ? "Active" : "Closed"}
                </span>
              );
            }}
            sx={{
              width: "140px",
              height: "36px",
              bgcolor: "#f5f5f5",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "transparent",
                },
                "&:hover fieldset": {
                  borderColor: "#1d82f5",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#1d82f5",
                },
              },
              "& .MuiSelect-select": {
                padding: "8px 32px 8px 12px",
                fontSize: "14px",
              },
            }}
            IconComponent={(props) => (
              <ExpandMoreIcon {...props} style={{ color: "#666", fontSize: "20px" }} />
            )}
          >
            <MenuItem value="">All Status</MenuItem>
            <MenuItem value="1">Active</MenuItem>
            <MenuItem value="0">Closed</MenuItem>
          </Select>
          {statusFilter && (
            <IconButton
              size="small"
              onClick={handleClearStatus}
              sx={{
                position: "absolute",
                right: "32px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#666",
                "&:hover": { color: "#1d82f5" },
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>

      <Box
        sx={{
          width: "320px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingLeft: "10px",
        }}
        className={styles.box}
      >
        <TextField
          placeholder="Search by location or client ID..."
          value={searchText}
          onChange={handleSearchChange}
          variant="outlined"
          size="small"
          sx={{
            width: "280px",
            bgcolor: "#f5f5f5",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "transparent",
              },
              "&:hover fieldset": {
                borderColor: "#1d82f5",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#1d82f5",
              },
            },
            "& .MuiInputBase-input": {
              color: "#000",
              fontSize: "14px",
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "#666" }} />
              </InputAdornment>
            ),
            endAdornment: searchText && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={handleClearSearch}
                  sx={{ color: "#666", "&:hover": { color: "#1d82f5" } }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {hasActiveFilters && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginLeft: "10px",
            gap: "8px",
            flexWrap: "wrap",
          }}
        >
          {selection && (
            <Chip
              label={`Duration: ${getDurationLabel(selection)}`}
              onDelete={handleClearDuration}
              size="small"
              sx={{
                bgcolor: "#e3f2fd",
                color: "#1976d2",
                "& .MuiChip-deleteIcon": {
                  color: "#1976d2",
                  "&:hover": { color: "#1565c0" },
                },
              }}
            />
          )}
          {statusFilter && (
            <Chip
              label={`Status: ${statusFilter === "1" ? "Active" : "Closed"}`}
              onDelete={handleClearStatus}
              size="small"
              sx={{
                bgcolor: "#e8f5e9",
                color: "#2e7d32",
                "& .MuiChip-deleteIcon": {
                  color: "#2e7d32",
                  "&:hover": { color: "#1b5e20" },
                },
              }}
            />
          )}
          {searchText && (
            <Chip
              label={`Search: ${searchText}`}
              onDelete={handleClearSearch}
              size="small"
              sx={{
                bgcolor: "#fff3e0",
                color: "#f57c00",
                "& .MuiChip-deleteIcon": {
                  color: "#f57c00",
                  "&:hover": { color: "#e65100" },
                },
              }}
            />
          )}
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={handleClearAll}
            sx={{
              height: "28px",
              borderColor: "#1d82f5",
              color: "#1d82f5",
              fontSize: "12px",
              textTransform: "none",
              minWidth: "auto",
              "&:hover": {
                backgroundColor: "#1d82f5",
                color: "white",
                borderColor: "#1d82f5",
              },
            }}
          >
            Clear All
          </Button>
        </Box>
      )}
    </Box>
  );
}
